/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {


    loadPopup: function( popupId ) {
      $.magnificPopup.open( {
        items: {
          src: popupId,
        },
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        autoFocusLast: true,
        focus: '.mfp-close',
        callbacks: {
          open: function() {
            $( 'body' ).addClass( 'pop-up-open' );
          },
        },
      }, 0 );
    },

    init: function() {
      const _this = this;

      // set local storage with expire time
      const setWithExpiry = ( key, value, ttl ) =>{
        const now = new Date();

        // `item` is an object with the original value and time its supposed to expire
        const item = {
          value: value,
          expiry: now.getTime() + ttl,
        };
        localStorage.setItem( key, JSON.stringify( item ) );
      };

      // pop up key
      const popupKey = 'fsgc_shown';

      const handleShowPopup = ( popupKey ) => {
        // get the local storage item
        const showPopup = localStorage.getItem( popupKey );

        // parse it to get the object
        const item = JSON.parse( showPopup );
        const now = new Date();
        const sitePopup = {
          items: {
            src: '#modal-popup',
          },
          type: 'inline',
          fixedContentPos: true,
          fixedBgPos: true,
          overflowY: 'auto',
          closeBtnInside: true,
          preloader: false,
          midClick: true,
          removalDelay: 300,
          autoFocusLast: true,
          focus: '.mfp-close',
        };

        // if showPopup doesn't exist add it
        if ( showPopup === null ) {
          $.magnificPopup.open( sitePopup, 0 );

          // value the localstorage item will expire after
          const ttl = 2629800000; // one month in milliseconds

          setWithExpiry( popupKey, true, ttl );

          // if it exists and the expire time as lapsed show it and set it with a new expire time
        } else if ( showPopup && now.getTime() > item.expiry ) {
          $.magnificPopup.open( sitePopup, 0 );
          // remove from storage
          localStorage.removeItem( popupKey );

          // add it back in with new time
          // value the localstorage item will expire after
          const ttl = 2629800000; // one month in milliseconds
          setWithExpiry( popupKey, true, ttl );
        }
      };


      $( document ).on( 'click', '.js-init-popup', function( e ) {
        e.preventDefault();
        const popupId = $( this ).data( 'modal' );

        if ( popupId !== '' ) {
          _this.loadPopup( popupId );
        }
      } );

      handleShowPopup( popupKey );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'modal', COMPONENT );
} )( app );
